import React, { Component } from 'react';
import { connect } from 'react-redux';
import { activateWebsite } from '../../Claim/activatewebsite';
import '../../../assets/css/dashboard.css';
import PopupModal from '../popups/PopupModal';
import apiInstance from '../../apiInstance';
import withRouter from '../../../utility/withRouter';

class Websites extends Component {
	
	constructor(props) {
        super(props);
        this.state = {
            websites: [],
            currentWebsite: {},
            currentSiteEmails: {},
            currentSiteBackups: {},
            currentSiteStorageUsed: 0,
            currentSiteStorageLimit: 0,
			domain: '',
            loadingWebsite: null,
            loadingCache: null,
            skeletonLoading: true,
            error: "",
            msg: ""
        };
        this.popupRef = React.createRef();
    }

	fetchSiteDetails = async (websiteId) => {
		if (!websiteId) {
			this.setState({ currentSiteEmails: [], currentSiteBackups: [] });
			return;
		}

		this.setState({ skeletonLoading: true });

		try {
			const [emailsResponse, backupsResponse] = await Promise.all([
				apiInstance.get(`/dashboard/emails/${websiteId}`),
				apiInstance.get(`/dashboard/backups/${websiteId}`)
			]);
			this.setState({ error: "", msg: "" });
			this.setState({
				currentSiteEmails: emailsResponse.data.emails.emails,
				currentSiteBackups: backupsResponse.data.backups,
                currentSiteStorageUsed: backupsResponse.data.storage.storage_used,
                currentSiteStorageLimit: backupsResponse.data.storage.storage_limit,
			});
		} catch (error) {
			console.error("Error fetching site details:", error);
			this.setState({
				error: error.response?.data?.message || error.message || "Failed to load site details.",
				currentSiteEmails: [],
				currentSiteBackups: [],
			});
		} finally {
			this.setState({ skeletonLoading: false });
		}
	};

	async componentDidMount() {
		try {
			const response = await apiInstance.get('/dashboard/websites');
			const websites = response.data.websites;
			let currentWebsite = null;

			const storedWebsiteId = localStorage.getItem('currentWebsiteId');

			if (storedWebsiteId) {
				currentWebsite = websites.find(site => site._id === storedWebsiteId);
			}

			if (!currentWebsite && websites.length > 0) {
				currentWebsite = websites[0];
			}

			this.setState({ websites, currentWebsite });

			if (currentWebsite) {
				localStorage.setItem('currentWebsiteId', currentWebsite._id);
				await this.fetchSiteDetails(currentWebsite._id);
			} else {
				this.setState({ skeletonLoading: false }); 
			}

		} catch (error) {
			console.error('Error fetching data:', error);
			this.setState({ error: error.response?.data?.message || "Failed to load websites." });
			this.setState({ skeletonLoading: false });
		}
	}
	
	handleChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	}

    loginDashboard = (websiteId) => {
        
        this.setState({loadingWebsite: websiteId});
        apiInstance.get(`/dashboard/magiclink/${websiteId}`)
            .then((response) => {
				const magicLink = response.data.link;
                if(magicLink){
                    window.open(magicLink, '_blank');
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                this.setState({ error: error.response?.data?.message ||error.response?.data || "Something went wrong, please try again later." });
            })
            .finally(() => {
                this.setState({loadingWebsite: null});
            });
    }
    
    clearCache = (websiteId) => {
        
        this.setState({loadingCache: websiteId});
        apiInstance.get(`/dashboard/flushcache/${websiteId}`)
            .then((response) => {
				const msg = response.data.msg;
                if(msg){
                    this.setState({ msg: "Cache cleared successfully!" });
                }
            })
            .catch(error => {
                console.error('Error clearing cache:', error);
                this.setState({ error: error.response?.data?.message ||error.response?.data || "Something went wrong, please try again later." });
            })
            .finally(() => {
                this.setState({loadingCache: null});
            });
    }

    handleCurrentSiteChange = async (e) => {
        const selectedSite = e.target.value;
        let siteIndex = 0;
        this.state.websites.map((website, index) =>
            website.siteName === selectedSite ? (siteIndex = index) : ""
        );
        const currentWebsite = this.state.websites[siteIndex];
        this.setState({ currentWebsite: currentWebsite });
		
        if (currentWebsite) {
			localStorage.setItem('currentWebsiteId', currentWebsite._id);
            await this.fetchSiteDetails(currentWebsite._id);
        } else {
			localStorage.removeItem('currentWebsiteId');
			this.setState({ currentSiteEmails: [], currentSiteBackups: [], skeletonLoading: false });
        }
    };

    formatDate(isoString) {
        const date = new Date(isoString);
        const datePart = new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        }).format(date);

        const timePart = new Intl.DateTimeFormat(undefined, {
            hour: 'numeric',
            minute: '2-digit'
        }).format(date);

        return `${datePart} at ${timePart}`;
    }

    updateWebsiteHandler = (website) => {
        
        this.setState(prevState => ({
            websites: prevState.websites.map(item =>
                item._id === website.id
                    ? { ...item, ...website }  
                    : item
            )
        }));
    };

    activateNow = async (siteId) => {
        try {
            await activateWebsite({
                siteId,
                userEmail: this.props.user?.email
            });
        } catch (err) {
            console.error('Checkout failed:', err.message);
            this.setState({ error: err.message || "Request failed. Please contact us." });
        }
    }

    formatBytes(bytes) {
        if (!bytes || bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
    }

    render() {

        const websites = Array.isArray(this.state.websites) ? this.state.websites : [];
        const loadingWebsite = this.state.loadingWebsite;
        const loadingCache = this.state.loadingCache;
        const skeletonLoading = this.state.skeletonLoading;

        const currSiteId = this.state.currentWebsite?._id;
        const currSiteCodeName = this.state.currentWebsite?.siteName;
        const currSiteName = this.state.currentWebsite?.name;
        const currSiteUrl = this.state.currentWebsite?.siteUrl;
        const cleanCurrSiteUrl = currSiteUrl?.replace('https://', '');
        const currSiteStatus = this.state.currentWebsite?.status;

        const currentSiteStorageUsed = this.formatBytes(this.state.currentSiteStorageUsed) || '0 KB';
        const currentSiteStorageLimit = this.formatBytes(this.state.currentSiteStorageLimit) || '1 GB';
        
        const mainDomain = process.env.REACT_APP_MAIN_DOMAIN;
        const isTestSite = this.state.currentWebsite?.siteUrl?.includes(mainDomain);

        const currSiteEmailsCount = this.state.currentSiteEmails?.length || 0;
        const currSiteBackups = this.state.currentSiteBackups;
        const currSiteLatestBackupDateIso = currSiteBackups?.manual?.[0]?.createdAt || null;
        const currSiteLatestBackupDate = currSiteLatestBackupDateIso ? this.formatDate(currSiteLatestBackupDateIso) : 'N/A';
        const currSiteSubscriptionStatus = this.state.currentWebsite?.subscription?.status || '-';

        const {error, msg} = this.state;
        
        return (
            <>
                {websites?.length > 0 &&
                    <div className="mjs-dash-top">
                        <div className="mjs-dash-top-site-dd">
                            <span>Active Website </span>
                            <select
                                className="mjs-select"
                                value={currSiteCodeName}
                                onChange={this.handleCurrentSiteChange}
                            >
                                {websites.map((website, index) => (
                                    <option
                                        key={website._id}
                                        value={website.siteName}
                                    >
                                        {website.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <span
                                className='mjs-btn'
                                onClick={() => {
                                    if (this.popupRef.current) {
                                        this.popupRef.current.openPopup(
                                            "requestWebsite"
                                        );
                                    }
                                }}
                            >
                                Request New Website
                            </span>
                        </div>
                    </div>
                }

                <div className="mjs-dash-section">
                    {error && <p className='mjs_text_error'>{error}</p> }   
                    {msg && <p className='mjs-message'>{msg}</p> }

                    {websites?.length > 0 ?
                    <>

                        <div className="mjs-dash-sec-card">
                            {
                            skeletonLoading !== false ? 
                                <>
                                    <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-5'></div>
                                    <div className='mjs_pre_skeleton_text mjs-width-15'></div>

                                    <div className="mjs-dash-card-action-btns mjs-mt-30">
                                        <div className='mjs_pre_skeleton_btn mjs-width-10'></div>
                                        <div className='mjs_pre_skeleton_btn mjs-width-10'></div>
                                        <div className='mjs_pre_skeleton_btn mjs-width-10'></div>
                                    </div>
                                </>
                                :
                                <>
                                    <h4>{currSiteName}</h4>
                                    <p>
                                        {currSiteStatus !== 'paused' ?
                                            <span><i class="mjs_text_green fa-solid fa-circle"></i> Live</span>
                                            :
                                            <span><i class="mjs_text_error fa-solid fa-circle-exclamation"></i> Down</span>
                                        }
                                    </p>
                                    <a class="mjs-i-action mjs-link" href={currSiteUrl} target="_blank" rel="noreferrer"><i class="fa-solid fa-globe"></i> {cleanCurrSiteUrl} <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                                    
                                    <p className="mjs-dash-card-action-btns mjs-mt-30">
                                        {currSiteSubscriptionStatus !== 'active' ?
                                            <>
                                                <span className='mjs-btn mjs-btn-primary' onClick={() => this.activateNow(currSiteId)}>Activate Now</span>
                                                <a class="mjs-btn" href={currSiteUrl} target="_blank" rel="noreferrer">Open Website</a>
                                            </>
                                            :
                                            <a class="mjs-btn mjs-btn-primary" href={currSiteUrl} target="_blank" rel="noreferrer">Open Website</a>
                                        }

                                        <span className='mjs-i-action'>
                                            <span className="mjs-btn" onClick={() => this.loginDashboard(currSiteId)}>Manage Website</span>
                                            {loadingWebsite === currSiteId && <i id="mjs-login-spin" className="fa-solid fa-spinner fa-spin"></i>}
                                        </span>
                                        <span className='mjs-i-action'>
                                            <span className="mjs-btn" onClick={() => this.clearCache(currSiteId)}>Clear Cache</span>
                                            {loadingCache === currSiteId && <i className="fa-solid fa-spinner fa-spin"></i>}
                                        </span>
                                    </p>

                                    {
                                        currSiteSubscriptionStatus !== 'active' &&
                                        <p>
                                            <span className='mjs-mr-10 mjs_text_error'>Your website is not fully activated yet. Unlock domain connection, business email and automatic backups by activating now.</span>
                                        </p>
                                    }


                                </>
                            }
                            
                        </div>

                        <div className="mjs-dash-sec-card-container">

                            <div className="mjs-dash-sec-card mjs-width-25">
                                <h5><i class="fa-solid fa-globe mjs_text_grey"></i> Domain</h5>
                                    {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-30'></p>
                                    </>
                                    :
                                    <>
                                        {
                                        isTestSite ? 
                                        <>
                                            <p><i class="fa-solid fa-circle-exclamation mjs_text_error"></i> Not Connected</p>
                                            <p>Your website is using a temporary address</p>
                                            <p><span className="mjs-quick-action-link" onClick={() => this.props.navigate("/domains")}>Connect Domain</span></p>
                                        </>
                                        :
                                        <p><i class="mjs_text_green fa-solid fa-check"></i> Connected</p>
                                        }
                                    </>
                                    }
                            </div>

                            <div className="mjs-dash-sec-card mjs-width-25">
                                <h5><i class="fa-regular fa-envelope mjs_text_grey"></i> Business Email</h5>
                                {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-30'></p>
                                    </>
                                    :
                                    <>
                                        <p>{currSiteEmailsCount} {currSiteEmailsCount == 1 ? "Account" : "Accounts"}</p>
                                        {
                                        currSiteEmailsCount === 0 ?
                                            <p><span className="mjs-quick-action-link" onClick={() => this.props.navigate("/emails")}>Create Your First Email Account</span></p>
                                        :
                                            <p><span className="mjs-quick-action-link" onClick={() => this.props.navigate("/emails")}>Access Emails</span></p>
                                        }
                                    </>
                                }
                            </div>

                            <div className="mjs-dash-sec-card mjs-width-25">
                                <h5><i class="fa-solid fa-database mjs_text_grey"></i> Backups</h5>
                                {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-30'></p>
                                    </>
                                    :
                                    <>
                                        <p>Last Backup - {currSiteLatestBackupDate}</p>
                                        <p><span className="mjs-quick-action-link" onClick={() => this.props.navigate("/backups")}>Manage backups</span></p>
                                    </>
                                }
                            </div>
                            
                            <div className="mjs-dash-sec-card mjs-width-25">
                                <h5><i class="fa-solid fa-credit-card mjs_text_grey"></i> Plan</h5>
                                {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-30'></p>
                                    </>
                                    :
                                    <>
                                        {
                                        currSiteSubscriptionStatus === 'active' && currSiteStatus !== 'paused' ?
                                            <p><span><i class="mjs_text_green fa-solid fa-circle-check"></i> Active</span></p>
                                        :
                                            <p><span><i class="fa-solid fa-circle-exclamation mjs_text_error"></i> Inactive</span></p>
                                        }
                                        <p><span className="mjs-quick-action-link" onClick={() => this.props.navigate("/billing")}>More Details</span></p>
                                    </>
                                }
                            </div>
                        </div>

                        <div className="mjs-dash-sec-card-container">
                            <div className="mjs-width-70">
                                <h4>Finish Setting up Your Website</h4>
                            </div>
                            <div className="mjs-width-30">
                                <h4>Advanced</h4>
                            </div>
                        </div>

                        <div className="mjs-dash-sec-card-container">

                            <div className="mjs-dash-sec-card mjs-width-40 mjs-check-list">
                                <div><i class="mjs_text_light_blue fa-solid fa-check"></i> Website created</div>
                                {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-50'></p>
                                        <p className='mjs_pre_skeleton_text mjs-width-60'></p>
                                        <p className='mjs_pre_skeleton_text mjs-width-40'></p>
                                    </>
                                    :
                                    <>
                                        <div>{isTestSite ? <i class="mjs_text_grey fa-solid fa-hourglass"></i> : <i class="mjs_text_light_blue fa-solid fa-check"></i>} Connect your domain</div>
                                        <div>{currSiteEmailsCount === 0 ? <i class="mjs_text_grey fa-solid fa-hourglass"></i> : <i class="mjs_text_light_blue fa-solid fa-check"></i>} Create business email</div>
                                        <div><i class="mjs_text_light_blue fa-solid fa-check"></i> Review site content</div>
                                    </>
                                }
                            </div>

                            <div className="mjs-dash-sec-card mjs-width-30">
                                {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-50'></p>
                                        <p className='mjs_pre_skeleton_text mjs-width-70'></p>
                                        <p className='mjs_pre_skeleton_text mjs-width-40'></p>
                                    </>
                                    :
                                    <>
                                        {/* fa-gauge */}
                                        <h5><i class="fa-solid fa-bolt mjs_text_grey"></i> Site Stats</h5>
                                        <p><span>Storage: </span></p>
                                        <p>{currentSiteStorageUsed} / {currentSiteStorageLimit}</p>
                                    </>
                                }
                            </div>

                            <div className="mjs-dash-sec-card mjs-width-30">
                                {
                                    skeletonLoading !== false ? 
                                    <>
                                        <p className='mjs_pre_skeleton_text mjs-width-50'></p>
                                        <p className='mjs_pre_skeleton_text mjs-width-70'></p>
                                        <p className='mjs_pre_skeleton_text mjs-width-40'></p>
                                    </>
                                    :
                                    <>
                                        {currSiteStatus !== 'paused' ?
                                            <>
                                            <h5><i class="fa-solid fa-trash-can mjs_text_grey"></i> Delete Website</h5>
                                            <p>This will remove your website and cancel the subscription.</p>
                                            </>
                                            :
                                            <>
                                            <h5><i class="fa-solid fa-hammer mjs_text_grey"></i> Recover Website</h5>
                                            <p>If you accidentally removed your website, click this button to reach out to us for a recovery.</p>
                                            </>
                                        }
                                        
                                        <p>
                                            {currSiteStatus !== 'paused' ?
                                                currSiteSubscriptionStatus === "active" ?
                                                    <span className="mjs-btn mjs_text_error" 
                                                        onClick={() => {
                                                            if (this.popupRef.current) {
                                                                this.popupRef.current.openPopup(
                                                                    "deleteWebsite",
                                                                    { websiteId: currSiteId }
                                                                );
                                                            }
                                                        }}
                                                    >Remove Website</span>
                                                :
                                                    <span className="mjs-btn mjs_text_error disabled">Remove Website</span>
                                            :
                                            <span className="mjs-btn mjs-bg-success" onClick={() => this.props.navigate("/support")}>Request Recover</span>
                                            }
                                        </p>
                                    </>
                                }
                            </div>

                        </div>
                    </>
                    :
                    <>
                        {skeletonLoading !== false ? 
                            <div className='mjs_pre_skeleton_text mjs-width-20'></div>
                        :
                            <p className='mjs_text_error'>You don't have any website yet!.</p>
                        }
                    </>
                    }

                </div>
            <PopupModal
                ref={this.popupRef}
                updateWebsite={this.updateWebsiteHandler}
            />
            </>
        );
    }

}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(withRouter(Websites));
